import { useAppMeta } from "hooks";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import React from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  useGetContractorUserDataDetailQuery,
  useUpdateContractorUserDataMutation,
} from "store/services/contractorUserApi";
import ContractorUserForm from "./contractorComponents/ContractorUserForm";

const ContractorUserEditScreen = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Contractor", path: "/app/crm/contractorUser/list" },
    { title: "Edit Contractor User" },
  ];

  // RTK Query
  const {
    data: contractorUserDetail,
    isLoading: loadingContractorUser,
    error,
  } = useGetContractorUserDataDetailQuery(id);

  const [updateContractorUser, { isLoading: updatingContractorUser }] =
    useUpdateContractorUserDataMutation();

  // Submit Handler
  const handleUpdateContractorUser = async (data) => {
    try {
      await updateContractorUser(data).unwrap();
      toast.success("Contractor user successfully updated!");
      navigate(`/app/crm/contractorUser/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update Contractor User!"
      );
    }
  };

  useAppMeta("Edit Contractor User");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingContractorUser || updatingContractorUser}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <ContractorUserForm
          contractorUserDetail={contractorUserDetail}
          isBusy={loadingContractorUser || updatingContractorUser}
          onSubmit={handleUpdateContractorUser}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default ContractorUserEditScreen;
